import axiosHttp from "./interceptor.service";

const getCaseHistory = ({
  sort,
  search,
  limit,
  page,
  isAssigned,
  isManagement,
  isRead,
  type,
  assignedTo,
  ticketStatus,
  progressStatus,
  startDate,
  endDate,
  assignedStartDate,
  assignedEndDate,
  updatedStartDate,
  updatedEndDate,
  closedStartDate,
  closedEndDate,
  isExpired,
  sendStatus,
  timerRangeType,
  timerStatus,
  timerType,
  webUserId,
  role,
} = {}) => {
  return axiosHttp.get("/feedback/getCaseHistory", {
    params: {
      sort,
      search,
      limit,
      page,
      isAssigned,
      isManagement,
      isRead,
      type,
      assignedTo,
      ticketStatus,
      progressStatus,
      startDate,
      endDate,
      assignedStartDate,
      assignedEndDate,
      updatedStartDate,
      updatedEndDate,
      closedStartDate,
      closedEndDate,
      isExpired,
      sendStatus,
      timerType,
      timerRangeType,
      timerStatus,
      webUserId,
      role
    },
  });
};

const addConversation = (ticketId, data) => {
  return axiosHttp.put(`/feedback/addConversation/${ticketId}`, data);
};
const getChatConversation = (ticketId, data) => {
  return axiosHttp.get(`/feedback/getChatConversationWeb/${ticketId}`, data);
};

const closeTicket = (ticketId, data) => {
  return axiosHttp.put(`/feedback/updateTicketStatus/${ticketId}`, data);
};
const alertCloseMessage = (data) => {
  return axiosHttp.put(`/feedback/alertMessageToCloseChat`, data);
};

const updateCaseHistory = (id, data) => {
  return axiosHttp.put(`/feedback/updateCaseHistory/${id}`, data);
};

const deleteTicket = (id) => {
  return axiosHttp.delete(`/feedback/deleteTicket/${id}`);
};

const publicHolidays = () => {
  return axiosHttp.get("/feedback/publicholiday");
};

const getCaseHistoryCount = (params) => {
  return axiosHttp.get("/feedback/getCaseHistoryCount", { params });
};

export {
  getCaseHistory,
  addConversation,
  getChatConversation,
  closeTicket,
  alertCloseMessage,
  updateCaseHistory,
  deleteTicket,
  publicHolidays,
  getCaseHistoryCount,
};
